export class BankMaster {
    CLIENT_ID: number;
    ID: number;
    NAME: string;
    SHORT_NAME: string;
    STATUS: boolean = true;
}